module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "d66s2c55",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
};
